import moment from 'moment'
import { findTarget } from '../../../../../../utils/microcopy.utils'
import UrlUtil from '../../../../../../utils/url.utils'
import { urlFormattedTypeParam } from './url'

export const getPageNumber = (pageNumber: number) => {
  if (typeof window !== 'undefined' && window.location.pathname) {
    const numberInUrl = window.location.pathname.match(/[0-9]+/)

    if (numberInUrl && numberInUrl[0]) {
      return parseInt(numberInUrl[0])
    }
  } else {
    if (pageNumber) {
      return pageNumber
    }
  }

  return 1
}

export const gatherAllYears = (listings: any) => {
  const years = new Set()

  listings.forEach((listing: any) => {
    const date = new Date(listing.date)

    if (date) {
      listing.date ? years.add(moment(date).utc().format('YYYY')) : ''
    }
  })

  return Array.from(years)
}

export const getQueryParams = (
  LISTING_TYPES: any,
  yearTextParameter: any,
  typeTextParameter: any,
) => {
  const yearParam = UrlUtil.getUrlParameter(yearTextParameter)
  let typeParam = UrlUtil.getUrlParameter(typeTextParameter)

  //* If the type is not Press Release or Media Coverage, ignore it
  if (urlFormattedTypeParam(LISTING_TYPES.PRESS_RELEASES) === typeParam) {
    typeParam = LISTING_TYPES.PRESS_RELEASES
  } else if (urlFormattedTypeParam(LISTING_TYPES.MEDIA_COVERAGE) === typeParam) {
    typeParam = LISTING_TYPES.MEDIA_COVERAGE
  } else {
    typeParam = ''
  }

  return [yearParam, typeParam]
}

export const getMicrocopies = (microcopy: any) => {
  const LISTING_TYPES = {
    ALL_ARTICLES:
      microcopy.values && (findTarget('AllTAB.text', microcopy.values, false) || 'All Articles'),
    PRESS_RELEASES:
      microcopy.values &&
      (findTarget('PressTAB.text', microcopy.values, false) || 'Press Releases'),
    MEDIA_COVERAGE:
      microcopy.values &&
      (findTarget('MediaTAB.text', microcopy.values, false) || 'Media Coverage'),
  }

  const yearTextParameter =
    microcopy.values &&
    (findTarget('YearFILTER.text', microcopy.values, false) || 'year')
      .split(' ')
      .join('-')
      .toLowerCase()

  const typeTextParameter =
    microcopy.values &&
    (findTarget('TypeURL.text', microcopy.values, false) || 'type')
      .split(' ')
      .join('-')
      .toLowerCase()

  const financialNewsText =
    microcopy.values &&
    (findTarget('FinancialNews.text', microcopy.values, false) || 'Go and Explore')

  const financialNewsLinkText =
    microcopy.values &&
    (findTarget('InvestorRelations.text', microcopy.values, false) || 'Investor Relations')

  const financialNewsLinkUrl =
    microcopy.values && (findTarget('InvestorRelations.url', microcopy.values, false) || '#')

  const mobileYearFilterText =
    microcopy.values && (findTarget('AllYears.text', microcopy.values, false) || 'All Years')

  return {
    LISTING_TYPES,
    yearTextParameter,
    typeTextParameter,
    financialNewsText,
    financialNewsLinkText,
    financialNewsLinkUrl,
    mobileYearFilterText,
  }
}
